// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-area {
  --admin-blue: #1769e8;
  --admin-line: #e5eaf2;
  --admin-muted: #68758b;
  /* Keep the admin workspace readable inside the shell's compact layout. */
  zoom: calc(1 / var(--dataspace-ui-scale, 1));
  font-size: 15px;
  line-height: 1.55;
  min-width: 0;
  min-height: 100%;
  color: #14213b;
  background: #f8fafd;
  font-family: Manrope, "Segoe UI", sans-serif;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.admin-area * {
  box-sizing: border-box;
}
.admin-area h1,
.admin-area h2,
.admin-area p {
  margin: 0;
}
.admin-area h1 {
  font-size: 32px;
  letter-spacing: -0.6px;
}
.admin-area h2 {
  font-size: 20px;
}
.admin-area p {
  color: var(--admin-muted);
  font-size: 15px;
  line-height: 1.7;
}
.admin-header {
  margin: 0 !important;
  box-shadow: none !important;
}
.admin-header .crumb > svg {
  color: var(--admin-blue);
}
.admin-context {
  padding: 28px 32px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.admin-context label {
  min-width: 0;
}
.admin-context small {
  font-size: 13px;
  display: block;
  color: var(--admin-muted);
  margin-bottom: 6px;
}
.admin-context select {
  max-width: 100%;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 22px;
  font-weight: 800;
  color: #14213b;
  padding-right: 20px;
  min-height: 44px;
}
.admin-chip {
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 16px;
  background: #eaf2ff;
  color: #35689f;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}
.admin-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 32px 18px;
  overflow-x: auto;
  scrollbar-width: thin;
  border-bottom: 1px solid var(--admin-line);
}
.admin-nav button {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 9px;
  padding: 12px 16px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #60718b;
  cursor: pointer;
  min-height: 46px;
  white-space: nowrap;
}
.admin-nav button.is-active {
  background: #eaf2ff;
  border-color: #cfe0fa;
  color: #1769e8;
  font-weight: 800;
}
.admin-nav button:hover {
  background: #edf4ff;
}
.admin-nav svg {
  width: 18px;
  height: 18px;
}
.admin-mobile-nav {
  display: none;
}
.admin-content {
  padding: 30px 32px;
  flex: 1 1;
  min-width: 0;
}
.admin-page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 22px;
  flex-wrap: wrap;
}
.admin-page-heading p {
  margin-top: 6px;
}
.admin-panel {
  min-width: 0;
  background: white;
  border: 1px solid var(--admin-line);
  border-radius: 13px;
  padding: 26px;
  margin-bottom: 22px;
}
.admin-panel-heading {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.admin-grid,
.admin-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}
.admin-grid > .admin-panel {
  margin-bottom: 0;
}
.admin-grid {
  margin-bottom: 18px;
}
.admin-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #334766;
}
.admin-field input,
.admin-field textarea,
.admin-field select {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 48px;
  border: 1px solid #dce4ef;
  background: white;
  color: #23344f;
  border-radius: 9px;
  padding: 12px 14px;
  font: inherit;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}
.admin-field textarea {
  resize: vertical;
}
.admin-field small,
.admin-hint {
  color: var(--admin-muted);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.7;
}
.admin-hint {
  margin-top: 15px !important;
}
.admin-inline {
  display: flex;
  gap: 22px;
  align-items: center;
  flex-wrap: wrap;
  margin: 14px 0;
}
.admin-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 12px 16px;
  border: 1px solid #dce4ef;
  border-radius: 9px;
  background: white;
  color: #334766;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: none;
  white-space: normal;
}
.admin-btn--primary {
  background: #1769e8;
  color: white;
  border-color: #1769e8;
}
.admin-btn:hover:not(:disabled) {
  background: #edf4ff;
  color: #1769e8;
}
.admin-btn--primary:hover:not(:disabled) {
  background: #125acb;
  color: white;
}
.admin-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.admin-area button:focus-visible,
.admin-area input:focus-visible,
.admin-area select:focus-visible,
.admin-area textarea:focus-visible {
  outline: 3px solid #76aaff;
  outline-offset: 3px;
}
.admin-icon-btn {
  display: grid;
  place-items: center;
  width: 44px;
  min-height: 44px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #60718b;
  cursor: pointer;
  flex-shrink: 0;
}
.admin-icon-btn:hover {
  background: #eaf2ff;
  color: #1769e8;
}
.admin-icon-btn svg {
  width: 20px;
  height: 20px;
}
.admin-symbol {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 11px;
  background: #eaf2ff;
  color: #2375e5;
}
.admin-symbol svg {
  width: 24px;
  height: 24px;
}
.admin-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.admin-metric {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px;
}
.admin-metric strong {
  font-size: 28px;
  letter-spacing: -0.5px;
}
.admin-metric p {
  font-size: 13px;
}
.admin-quick {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  color: inherit;
  text-align: left;
  font: inherit;
}
.admin-quick > svg {
  margin-left: auto;
  color: #7c90af;
}
.admin-quick:hover {
  border-color: #95b9ee;
}
.admin-apps {
  padding: 0;
  overflow: hidden;
}
.admin-app-heading,
.admin-app-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px 100px 44px;
  align-items: center;
  gap: 16px;
  padding: 20px 26px;
  border-bottom: 1px solid #edf0f5;
}
.admin-app-heading {
  font-size: 13px;
  font-weight: 700;
  color: var(--admin-muted);
  background: #fbfcfe;
  padding-block: 13px;
}
.admin-app-row:last-child {
  border: 0;
}
.admin-app-info {
  display: flex;
  gap: 14px;
  align-items: center;
  min-width: 0;
}
.admin-app-info strong {
  display: block;
  font-size: 15px;
  overflow-wrap: anywhere;
}
.admin-app-info small {
  display: block;
  font-size: 13px;
  color: var(--admin-muted);
  margin-top: 4px;
  overflow-wrap: anywhere;
}
.admin-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #52667f;
  min-height: 44px;
  cursor: pointer;
}
.admin-toggle input {
  appearance: none;
  -webkit-appearance: none;
  width: 44px;
  height: 26px;
  min-height: 26px;
  flex: 0 0 44px;
  margin: 0;
  padding: 3px;
  border: 0;
  border-radius: 20px;
  background: #ccd6e4;
  cursor: pointer;
}
.admin-toggle input:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
}
.admin-toggle input:checked {
  background: #1769e8;
}
.admin-toggle input:checked:before {
  margin-left: 18px;
}
.admin-toggle input:disabled {
  opacity: 0.5;
  cursor: default;
}
.admin-app-row .admin-toggle > span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
}
.admin-list-card {
  border: 1px solid var(--admin-line);
  border-radius: 11px;
  padding: 18px;
  margin-top: 14px;
  min-width: 0;
}
.admin-list-card > .admin-btn {
  margin-top: 12px;
}
.admin-person {
  display: flex;
  align-items: flex-start;
  gap: 13px;
}
.admin-person > div {
  flex: 1 1;
  min-width: 0;
}
.admin-person strong {
  font-size: 15px;
}
.admin-person p,
.admin-webid {
  overflow-wrap: anywhere;
  font-size: 11px !important;
}
.admin-person .admin-chip {
  margin-top: 8px;
}
.admin-person > .admin-btn {
  margin: 0;
}
.admin-brand-preview {
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  border: 1px dashed #cfdaeb;
  border-radius: 10px;
  background: #f8fafd;
  padding: 20px;
}
.admin-brand-preview img {
  max-width: 160px;
  max-height: 100px;
  object-fit: contain;
}
.admin-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: #f1f6ff;
  color: #42658e;
  border: 1px solid #dce9fc;
  border-radius: 11px;
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 18px;
  overflow-wrap: anywhere;
}
.admin-notice > svg {
  margin-top: 3px;
  flex-shrink: 0;
}
.admin-notice--error {
  background: #fff4f4;
  border-color: #f1cccc;
  color: #a72b35;
}
.admin-notice .admin-btn {
  margin-left: 12px;
}
.admin-savebar {
  position: sticky;
  bottom: 0;
  z-index: 10;
  border-top: 1px solid var(--admin-line);
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 32px;
  min-height: 84px;
  flex-wrap: wrap;
}
.admin-savebar strong {
  font-size: 15px;
}
.admin-savebar small {
  display: block;
  font-size: 13px;
  color: var(--admin-muted);
  margin-top: 4px;
}
.admin-savebar > div:last-child {
  display: flex;
  gap: 10px;
}
.admin-modal {
  color: #14213b;
  border: 1px solid var(--admin-line);
  border-radius: 16px;
  padding: 28px;
  width: min(860px, calc(100% - 32px));
  max-height: calc(100dvh - 32px);
  overflow: auto;
  background: white;
  font-family: inherit;
  font-size: 15px;
}
.admin-modal::backdrop {
  background: #14213b66;
}
.admin-modal-heading {
  display: flex;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.admin-modal-heading h2 {
  margin: 0;
  font-size: 22px;
}
.admin-modal-content {
  min-width: 0;
}
.admin-modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  position: sticky;
  bottom: -24px;
  padding: 18px 0 0;
  margin-top: 20px;
  background: white;
}
.admin-diff {
  padding: 16px 0;
  border-bottom: 1px solid var(--admin-line);
  font-size: 15px;
}
.admin-diff > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  margin-top: 8px;
}
.admin-diff pre {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #f8fafd;
  border-radius: 8px;
  padding: 12px;
  font: inherit;
  line-height: 1.6;
  color: #52667f;
  max-height: 220px;
  overflow: auto;
}
.admin-diff pre:last-child {
  background: #edf4ff;
  color: #285c9b;
}
.admin-modal .admin-notice {
  margin-top: 18px;
}
.admin-area .statistics-dashboard {
  margin-bottom: 22px;
}
.admin-area .statistics-panel,
.admin-area .statistics-metric {
  box-shadow: none;
  border-color: var(--admin-line);
  border-radius: 13px;
}
.admin-area .statistics-header {
  box-shadow: none;
}
.admin-area .statistics-button {
  background: #1769e8;
  border-color: #1769e8;
}
@media (max-width: 1150px) {
  .admin-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .admin-nav {
    padding-inline: 22px;
  }
  .admin-content,
  .admin-context {
    padding-inline: 22px;
  }
}
@media (max-width: 760px) {
  .admin-nav {
    display: none;
  }
  .admin-mobile-nav {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 0 16px 14px;
    font-size: 13px;
    color: #68758b;
    border-bottom: 1px solid var(--admin-line);
  }
  .admin-mobile-nav select {
    min-width: 0;
    flex: 1 1;
    background: white;
    border: 1px solid var(--admin-line);
    border-radius: 9px;
    padding: 12px;
    font: inherit;
    font-size: 15px;
    color: #14213b;
  }
  .admin-context {
    padding: 18px 16px;
  }
  .admin-context select {
    font-size: 18px;
  }
  .admin-context small {
    font-size: 12px;
  }
  .admin-context .admin-chip {
    font-size: 12px;
  }
  .admin-content {
    padding: 20px 16px;
  }
  .admin-area h1 {
    font-size: 28px;
  }
  .admin-page-heading {
    gap: 12px;
  }
  .admin-grid,
  .admin-form-grid {
    grid-template-columns: 1fr;
  }
  .admin-panel {
    padding: 17px;
  }
  .admin-apps {
    padding: 0;
  }
  .admin-app-heading {
    display: none;
  }
  .admin-app-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 44px;
    padding: 17px 15px;
    gap: 9px;
  }
  .admin-app-info {
    grid-column: 1/-1;
  }
  .admin-app-row .admin-toggle > span {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip-path: none;
    font-size: 12px;
  }
  .admin-app-row .admin-toggle {
    font-size: 13px;
  }
  .admin-app-row .admin-toggle > span {
    font-size: 0;
  }
  .admin-app-row .admin-toggle:nth-child(2) > span:after {
    content: "Aktiv";
    font-size: 13px;
  }
  .admin-app-row .admin-toggle:nth-child(3) > span:after {
    content: "Im Menü";
    font-size: 13px;
  }
  .admin-metric {
    padding: 13px;
    gap: 9px;
  }
  .admin-metric strong {
    font-size: 22px;
  }
  .admin-metric .admin-symbol {
    width: 40px;
    height: 40px;
  }
  .admin-metric p {
    font-size: 13px;
  }
  .admin-person {
    flex-wrap: wrap;
  }
  .admin-person .admin-btn {
    margin-left: auto;
  }
  .admin-savebar {
    padding: 16px;
    gap: 12px;
    align-items: stretch;
    flex-direction: column;
  }
  .admin-savebar strong {
    font-size: 13px;
  }
  .admin-savebar small {
    font-size: 12px;
  }
  .admin-savebar .admin-btn {
    padding: 10px;
    font-size: 13px;
    min-height: 44px;
  }
  .admin-savebar > div:last-child {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.6fr);
    gap: 10px;
  }
  .admin-savebar .admin-btn svg {
    display: none;
  }
  .admin-modal {
    padding: 18px;
    width: calc(100% - 20px);
    max-height: calc(100dvh - 20px);
  }
  .admin-modal-actions {
    bottom: -18px;
    flex-wrap: wrap;
  }
  .admin-diff > div {
    grid-template-columns: 1fr;
  }
  .admin-diff svg {
    transform: rotate(90deg);
    justify-self: center;
  }
  .admin-notice .admin-btn {
    margin: 10px 0 0;
  }
  .admin-notice {
    font-size: 13px;
  }
  .admin-field input,
  .admin-field textarea,
  .admin-field select {
    font-size: 16px;
  }
}

/* Match the shared app header while the workspace keeps its larger scale. */
.admin-area .admin-header {
  zoom: var(--dataspace-ui-scale, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  font-size: 1rem;
  line-height: normal;
}
.admin-modal[open] {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.admin-modal-heading {
  flex: 0 0 auto;
}
.admin-modal-content {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.admin-modal-actions {
  position: static;
  flex: 0 0 auto;
  padding-top: 16px;
}
@media (max-width: 760px) {
  .admin-modal .admin-icon-btn {
    width: 44px;
    min-height: 44px;
  }
}

.admin-area[lang="en"] .admin-app-row .admin-toggle:nth-child(2) > span::after {
  content: "Active";
}
.admin-area[lang="en"] .admin-app-row .admin-toggle:nth-child(3) > span::after {
  content: "In menu";
}
.admin-provisioning .admin-inline {
  flex-wrap: wrap;
}
.admin-context {
  flex-wrap: wrap;
}

.admin-modal--provisioning .admin-modal-content {
  display: flex;
  overflow: hidden;
}
.admin-provisioning {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
}
.admin-provisioning-body {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
}

.admin-page-heading > div,
.admin-metric > div,
.admin-quick > div,
.admin-savebar > div {
  min-width: 0;
  overflow-wrap: anywhere;
}
.admin-nav button,
.admin-btn,
.admin-toggle,
.admin-field,
.admin-notice {
  line-height: 1.5;
}
.admin-modal-actions {
  flex-wrap: wrap;
}
.admin-area .statistics-panel__header p,
.admin-area .statistics-runline,
.admin-area .statistics-table,
.admin-area .statistics-button {
  font-size: 14px;
}
.admin-area .statistics-metric__label,
.admin-area .statistics-table th,
.admin-area .statistics-table code,
.admin-area .statistics-download-types span,
.admin-area .statistics-quality-metric span,
.admin-area .statistics-semantic-model span,
.admin-area .statistics-survey-summary span {
  font-size: 13px;
}
.admin-area .statistics-chart__item {
  font-size: 12px;
}
.admin-area .statistics-button,
.admin-area .statistics-header.toolbar--title .pill-btn {
  min-height: 44px;
}
@media (max-width: 760px) {
  .admin-mobile-nav select {
    font-size: 16px;
    min-height: 48px;
  }
}
@media (max-width: 480px) {
  .admin-metrics {
    grid-template-columns: 1fr;
  }
  .admin-app-row {
    grid-template-columns: minmax(0, 1fr) 44px;
  }
  .admin-app-row .admin-toggle {
    grid-column: 1;
  }
  .admin-app-row > .admin-icon-btn {
    grid-column: 2;
    grid-row: 2 / span 2;
  }
  .admin-context label {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminArea.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,yEAAyE;EACzE,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,uCAAuC;EACvC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,0CAA0C;EAC5C;EACA;IACE,YAAY;IACZ,SAAO;IACP,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,eAAe;IACf,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,yDAAyD;IACzD,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sDAAsD;IACtD,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,wBAAwB;IACxB,+BAA+B;EACjC;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;AACF;;AAEA,4EAA4E;AAC5E;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,uBAAuB;AACzB;AACA;;;;;EAKE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,eAAe;AACjB;AACA;;;;;;;EAOE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".admin-area {\n  --admin-blue: #1769e8;\n  --admin-line: #e5eaf2;\n  --admin-muted: #68758b;\n  /* Keep the admin workspace readable inside the shell's compact layout. */\n  zoom: calc(1 / var(--dataspace-ui-scale, 1));\n  font-size: 15px;\n  line-height: 1.55;\n  min-width: 0;\n  min-height: 100%;\n  color: #14213b;\n  background: #f8fafd;\n  font-family: Manrope, \"Segoe UI\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n.admin-area * {\n  box-sizing: border-box;\n}\n.admin-area h1,\n.admin-area h2,\n.admin-area p {\n  margin: 0;\n}\n.admin-area h1 {\n  font-size: 32px;\n  letter-spacing: -0.6px;\n}\n.admin-area h2 {\n  font-size: 20px;\n}\n.admin-area p {\n  color: var(--admin-muted);\n  font-size: 15px;\n  line-height: 1.7;\n}\n.admin-header {\n  margin: 0 !important;\n  box-shadow: none !important;\n}\n.admin-header .crumb > svg {\n  color: var(--admin-blue);\n}\n.admin-context {\n  padding: 28px 32px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n.admin-context label {\n  min-width: 0;\n}\n.admin-context small {\n  font-size: 13px;\n  display: block;\n  color: var(--admin-muted);\n  margin-bottom: 6px;\n}\n.admin-context select {\n  max-width: 100%;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 22px;\n  font-weight: 800;\n  color: #14213b;\n  padding-right: 20px;\n  min-height: 44px;\n}\n.admin-chip {\n  display: inline-flex;\n  padding: 5px 10px;\n  border-radius: 16px;\n  background: #eaf2ff;\n  color: #35689f;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.admin-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 32px 18px;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  border-bottom: 1px solid var(--admin-line);\n}\n.admin-nav button {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  padding: 12px 16px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  color: #60718b;\n  cursor: pointer;\n  min-height: 46px;\n  white-space: nowrap;\n}\n.admin-nav button.is-active {\n  background: #eaf2ff;\n  border-color: #cfe0fa;\n  color: #1769e8;\n  font-weight: 800;\n}\n.admin-nav button:hover {\n  background: #edf4ff;\n}\n.admin-nav svg {\n  width: 18px;\n  height: 18px;\n}\n.admin-mobile-nav {\n  display: none;\n}\n.admin-content {\n  padding: 30px 32px;\n  flex: 1;\n  min-width: 0;\n}\n.admin-page-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  margin-bottom: 22px;\n  flex-wrap: wrap;\n}\n.admin-page-heading p {\n  margin-top: 6px;\n}\n.admin-panel {\n  min-width: 0;\n  background: white;\n  border: 1px solid var(--admin-line);\n  border-radius: 13px;\n  padding: 26px;\n  margin-bottom: 22px;\n}\n.admin-panel-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n.admin-grid,\n.admin-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 22px;\n}\n.admin-grid > .admin-panel {\n  margin-bottom: 0;\n}\n.admin-grid {\n  margin-bottom: 18px;\n}\n.admin-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #334766;\n}\n.admin-field input,\n.admin-field textarea,\n.admin-field select {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  min-height: 48px;\n  border: 1px solid #dce4ef;\n  background: white;\n  color: #23344f;\n  border-radius: 9px;\n  padding: 12px 14px;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n.admin-field textarea {\n  resize: vertical;\n}\n.admin-field small,\n.admin-hint {\n  color: var(--admin-muted);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.7;\n}\n.admin-hint {\n  margin-top: 15px !important;\n}\n.admin-inline {\n  display: flex;\n  gap: 22px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 14px 0;\n}\n.admin-btn {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  min-height: 46px;\n  padding: 12px 16px;\n  border: 1px solid #dce4ef;\n  border-radius: 9px;\n  background: white;\n  color: #334766;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: none;\n  white-space: normal;\n}\n.admin-btn--primary {\n  background: #1769e8;\n  color: white;\n  border-color: #1769e8;\n}\n.admin-btn:hover:not(:disabled) {\n  background: #edf4ff;\n  color: #1769e8;\n}\n.admin-btn--primary:hover:not(:disabled) {\n  background: #125acb;\n  color: white;\n}\n.admin-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n.admin-area button:focus-visible,\n.admin-area input:focus-visible,\n.admin-area select:focus-visible,\n.admin-area textarea:focus-visible {\n  outline: 3px solid #76aaff;\n  outline-offset: 3px;\n}\n.admin-icon-btn {\n  display: grid;\n  place-items: center;\n  width: 44px;\n  min-height: 44px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #60718b;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.admin-icon-btn:hover {\n  background: #eaf2ff;\n  color: #1769e8;\n}\n.admin-icon-btn svg {\n  width: 20px;\n  height: 20px;\n}\n.admin-symbol {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 11px;\n  background: #eaf2ff;\n  color: #2375e5;\n}\n.admin-symbol svg {\n  width: 24px;\n  height: 24px;\n}\n.admin-metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n.admin-metric {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 22px;\n}\n.admin-metric strong {\n  font-size: 28px;\n  letter-spacing: -0.5px;\n}\n.admin-metric p {\n  font-size: 13px;\n}\n.admin-quick {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  cursor: pointer;\n  color: inherit;\n  text-align: left;\n  font: inherit;\n}\n.admin-quick > svg {\n  margin-left: auto;\n  color: #7c90af;\n}\n.admin-quick:hover {\n  border-color: #95b9ee;\n}\n.admin-apps {\n  padding: 0;\n  overflow: hidden;\n}\n.admin-app-heading,\n.admin-app-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 100px 100px 44px;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 26px;\n  border-bottom: 1px solid #edf0f5;\n}\n.admin-app-heading {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--admin-muted);\n  background: #fbfcfe;\n  padding-block: 13px;\n}\n.admin-app-row:last-child {\n  border: 0;\n}\n.admin-app-info {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  min-width: 0;\n}\n.admin-app-info strong {\n  display: block;\n  font-size: 15px;\n  overflow-wrap: anywhere;\n}\n.admin-app-info small {\n  display: block;\n  font-size: 13px;\n  color: var(--admin-muted);\n  margin-top: 4px;\n  overflow-wrap: anywhere;\n}\n.admin-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #52667f;\n  min-height: 44px;\n  cursor: pointer;\n}\n.admin-toggle input {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 44px;\n  height: 26px;\n  min-height: 26px;\n  flex: 0 0 44px;\n  margin: 0;\n  padding: 3px;\n  border: 0;\n  border-radius: 20px;\n  background: #ccd6e4;\n  cursor: pointer;\n}\n.admin-toggle input:before {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: white;\n}\n.admin-toggle input:checked {\n  background: #1769e8;\n}\n.admin-toggle input:checked:before {\n  margin-left: 18px;\n}\n.admin-toggle input:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.admin-app-row .admin-toggle > span {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip-path: inset(50%);\n}\n.admin-list-card {\n  border: 1px solid var(--admin-line);\n  border-radius: 11px;\n  padding: 18px;\n  margin-top: 14px;\n  min-width: 0;\n}\n.admin-list-card > .admin-btn {\n  margin-top: 12px;\n}\n.admin-person {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n}\n.admin-person > div {\n  flex: 1;\n  min-width: 0;\n}\n.admin-person strong {\n  font-size: 15px;\n}\n.admin-person p,\n.admin-webid {\n  overflow-wrap: anywhere;\n  font-size: 11px !important;\n}\n.admin-person .admin-chip {\n  margin-top: 8px;\n}\n.admin-person > .admin-btn {\n  margin: 0;\n}\n.admin-brand-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  border: 1px dashed #cfdaeb;\n  border-radius: 10px;\n  background: #f8fafd;\n  padding: 20px;\n}\n.admin-brand-preview img {\n  max-width: 160px;\n  max-height: 100px;\n  object-fit: contain;\n}\n.admin-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px 16px;\n  background: #f1f6ff;\n  color: #42658e;\n  border: 1px solid #dce9fc;\n  border-radius: 11px;\n  font-size: 14px;\n  line-height: 1.7;\n  margin-bottom: 18px;\n  overflow-wrap: anywhere;\n}\n.admin-notice > svg {\n  margin-top: 3px;\n  flex-shrink: 0;\n}\n.admin-notice--error {\n  background: #fff4f4;\n  border-color: #f1cccc;\n  color: #a72b35;\n}\n.admin-notice .admin-btn {\n  margin-left: 12px;\n}\n.admin-savebar {\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n  border-top: 1px solid var(--admin-line);\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 32px;\n  min-height: 84px;\n  flex-wrap: wrap;\n}\n.admin-savebar strong {\n  font-size: 15px;\n}\n.admin-savebar small {\n  display: block;\n  font-size: 13px;\n  color: var(--admin-muted);\n  margin-top: 4px;\n}\n.admin-savebar > div:last-child {\n  display: flex;\n  gap: 10px;\n}\n.admin-modal {\n  color: #14213b;\n  border: 1px solid var(--admin-line);\n  border-radius: 16px;\n  padding: 28px;\n  width: min(860px, calc(100% - 32px));\n  max-height: calc(100dvh - 32px);\n  overflow: auto;\n  background: white;\n  font-family: inherit;\n  font-size: 15px;\n}\n.admin-modal::backdrop {\n  background: #14213b66;\n}\n.admin-modal-heading {\n  display: flex;\n  gap: 15px;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.admin-modal-heading h2 {\n  margin: 0;\n  font-size: 22px;\n}\n.admin-modal-content {\n  min-width: 0;\n}\n.admin-modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  position: sticky;\n  bottom: -24px;\n  padding: 18px 0 0;\n  margin-top: 20px;\n  background: white;\n}\n.admin-diff {\n  padding: 16px 0;\n  border-bottom: 1px solid var(--admin-line);\n  font-size: 15px;\n}\n.admin-diff > div {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr);\n  gap: 12px;\n  align-items: center;\n  margin-top: 8px;\n}\n.admin-diff pre {\n  margin: 0;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  background: #f8fafd;\n  border-radius: 8px;\n  padding: 12px;\n  font: inherit;\n  line-height: 1.6;\n  color: #52667f;\n  max-height: 220px;\n  overflow: auto;\n}\n.admin-diff pre:last-child {\n  background: #edf4ff;\n  color: #285c9b;\n}\n.admin-modal .admin-notice {\n  margin-top: 18px;\n}\n.admin-area .statistics-dashboard {\n  margin-bottom: 22px;\n}\n.admin-area .statistics-panel,\n.admin-area .statistics-metric {\n  box-shadow: none;\n  border-color: var(--admin-line);\n  border-radius: 13px;\n}\n.admin-area .statistics-header {\n  box-shadow: none;\n}\n.admin-area .statistics-button {\n  background: #1769e8;\n  border-color: #1769e8;\n}\n@media (max-width: 1150px) {\n  .admin-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .admin-nav {\n    padding-inline: 22px;\n  }\n  .admin-content,\n  .admin-context {\n    padding-inline: 22px;\n  }\n}\n@media (max-width: 760px) {\n  .admin-nav {\n    display: none;\n  }\n  .admin-mobile-nav {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    padding: 0 16px 14px;\n    font-size: 13px;\n    color: #68758b;\n    border-bottom: 1px solid var(--admin-line);\n  }\n  .admin-mobile-nav select {\n    min-width: 0;\n    flex: 1;\n    background: white;\n    border: 1px solid var(--admin-line);\n    border-radius: 9px;\n    padding: 12px;\n    font: inherit;\n    font-size: 15px;\n    color: #14213b;\n  }\n  .admin-context {\n    padding: 18px 16px;\n  }\n  .admin-context select {\n    font-size: 18px;\n  }\n  .admin-context small {\n    font-size: 12px;\n  }\n  .admin-context .admin-chip {\n    font-size: 12px;\n  }\n  .admin-content {\n    padding: 20px 16px;\n  }\n  .admin-area h1 {\n    font-size: 28px;\n  }\n  .admin-page-heading {\n    gap: 12px;\n  }\n  .admin-grid,\n  .admin-form-grid {\n    grid-template-columns: 1fr;\n  }\n  .admin-panel {\n    padding: 17px;\n  }\n  .admin-apps {\n    padding: 0;\n  }\n  .admin-app-heading {\n    display: none;\n  }\n  .admin-app-row {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 44px;\n    padding: 17px 15px;\n    gap: 9px;\n  }\n  .admin-app-info {\n    grid-column: 1/-1;\n  }\n  .admin-app-row .admin-toggle > span {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip-path: none;\n    font-size: 12px;\n  }\n  .admin-app-row .admin-toggle {\n    font-size: 13px;\n  }\n  .admin-app-row .admin-toggle > span {\n    font-size: 0;\n  }\n  .admin-app-row .admin-toggle:nth-child(2) > span:after {\n    content: \"Aktiv\";\n    font-size: 13px;\n  }\n  .admin-app-row .admin-toggle:nth-child(3) > span:after {\n    content: \"Im Menü\";\n    font-size: 13px;\n  }\n  .admin-metric {\n    padding: 13px;\n    gap: 9px;\n  }\n  .admin-metric strong {\n    font-size: 22px;\n  }\n  .admin-metric .admin-symbol {\n    width: 40px;\n    height: 40px;\n  }\n  .admin-metric p {\n    font-size: 13px;\n  }\n  .admin-person {\n    flex-wrap: wrap;\n  }\n  .admin-person .admin-btn {\n    margin-left: auto;\n  }\n  .admin-savebar {\n    padding: 16px;\n    gap: 12px;\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .admin-savebar strong {\n    font-size: 13px;\n  }\n  .admin-savebar small {\n    font-size: 12px;\n  }\n  .admin-savebar .admin-btn {\n    padding: 10px;\n    font-size: 13px;\n    min-height: 44px;\n  }\n  .admin-savebar > div:last-child {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.6fr);\n    gap: 10px;\n  }\n  .admin-savebar .admin-btn svg {\n    display: none;\n  }\n  .admin-modal {\n    padding: 18px;\n    width: calc(100% - 20px);\n    max-height: calc(100dvh - 20px);\n  }\n  .admin-modal-actions {\n    bottom: -18px;\n    flex-wrap: wrap;\n  }\n  .admin-diff > div {\n    grid-template-columns: 1fr;\n  }\n  .admin-diff svg {\n    transform: rotate(90deg);\n    justify-self: center;\n  }\n  .admin-notice .admin-btn {\n    margin: 10px 0 0;\n  }\n  .admin-notice {\n    font-size: 13px;\n  }\n  .admin-field input,\n  .admin-field textarea,\n  .admin-field select {\n    font-size: 16px;\n  }\n}\n\n/* Match the shared app header while the workspace keeps its larger scale. */\n.admin-area .admin-header {\n  zoom: var(--dataspace-ui-scale, 1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 auto;\n  font-size: 1rem;\n  line-height: normal;\n}\n.admin-modal[open] {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.admin-modal-heading {\n  flex: 0 0 auto;\n}\n.admin-modal-content {\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n.admin-modal-actions {\n  position: static;\n  flex: 0 0 auto;\n  padding-top: 16px;\n}\n@media (max-width: 760px) {\n  .admin-modal .admin-icon-btn {\n    width: 44px;\n    min-height: 44px;\n  }\n}\n\n.admin-area[lang=\"en\"] .admin-app-row .admin-toggle:nth-child(2) > span::after {\n  content: \"Active\";\n}\n.admin-area[lang=\"en\"] .admin-app-row .admin-toggle:nth-child(3) > span::after {\n  content: \"In menu\";\n}\n.admin-provisioning .admin-inline {\n  flex-wrap: wrap;\n}\n.admin-context {\n  flex-wrap: wrap;\n}\n\n.admin-modal--provisioning .admin-modal-content {\n  display: flex;\n  overflow: hidden;\n}\n.admin-provisioning {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n}\n.admin-provisioning-body {\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding-right: 4px;\n}\n\n.admin-page-heading > div,\n.admin-metric > div,\n.admin-quick > div,\n.admin-savebar > div {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.admin-nav button,\n.admin-btn,\n.admin-toggle,\n.admin-field,\n.admin-notice {\n  line-height: 1.5;\n}\n.admin-modal-actions {\n  flex-wrap: wrap;\n}\n.admin-area .statistics-panel__header p,\n.admin-area .statistics-runline,\n.admin-area .statistics-table,\n.admin-area .statistics-button {\n  font-size: 14px;\n}\n.admin-area .statistics-metric__label,\n.admin-area .statistics-table th,\n.admin-area .statistics-table code,\n.admin-area .statistics-download-types span,\n.admin-area .statistics-quality-metric span,\n.admin-area .statistics-semantic-model span,\n.admin-area .statistics-survey-summary span {\n  font-size: 13px;\n}\n.admin-area .statistics-chart__item {\n  font-size: 12px;\n}\n.admin-area .statistics-button,\n.admin-area .statistics-header.toolbar--title .pill-btn {\n  min-height: 44px;\n}\n@media (max-width: 760px) {\n  .admin-mobile-nav select {\n    font-size: 16px;\n    min-height: 48px;\n  }\n}\n@media (max-width: 480px) {\n  .admin-metrics {\n    grid-template-columns: 1fr;\n  }\n  .admin-app-row {\n    grid-template-columns: minmax(0, 1fr) 44px;\n  }\n  .admin-app-row .admin-toggle {\n    grid-column: 1;\n  }\n  .admin-app-row > .admin-icon-btn {\n    grid-column: 2;\n    grid-row: 2 / span 2;\n  }\n  .admin-context label {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
